// SP追従CTA。TOPはKV通過後、下層ページは常時表示し、フッター表示中は全ページで隠す。
export function initFloatingCta() {
  const cta = document.querySelector('[data-floating-cta]');
  if (!cta) return;

  const isHome = cta.hasAttribute('data-floating-cta-home');
  const kv = isHome ? document.getElementById('kv') : null;
  const footer = document.querySelector('.l-footer');

  let ticking = false;

  const update = () => {
    const hasPassedKv = !kv || window.scrollY >= kv.getBoundingClientRect().bottom + window.scrollY;
    const footerRect = footer ? footer.getBoundingClientRect() : null;
    const isFooterVisible = Boolean(
      footerRect
      && footerRect.top < window.innerHeight
      && footerRect.bottom > 0
    );
    const shouldShow = hasPassedKv && !isFooterVisible;

    cta.classList.toggle('is-visible', shouldShow);
    if (shouldShow) {
      cta.removeAttribute('aria-hidden');
    } else {
      cta.setAttribute('aria-hidden', 'true');
    }
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  update();
}
